module.exports = __webpack_public_path__ + "static/media/icon-outlook-calendar.d584cf61.svg";